import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Medal } from "lucide-react";

const GAMES = ["EA FC 26", "EA FC 25", "Valorant", "CS2", "Rocket League"];

export default function Leaderboard() {
  const [entries, setEntries] = useState([]);
  const [game, setGame] = useState("EA FC 26");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/leaderboard", { params: { game, limit: 50 } }).then((r) => {
      setEntries(r.data);
      setLoading(false);
    });
  }, [game]);

  const rankColor = (r) =>
    r === 1 ? "text-primary" : r === 2 ? "text-magenta" : r === 3 ? "text-accent" : "text-white/50";

  return (
    <div className="space-y-8 fade-in" data-testid="leaderboard-page">
      <div>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-primary">Ranglisten</div>
        <h1 className="font-display text-4xl tracking-tight mt-2">Leaderboard</h1>
        <p className="text-white/60 text-sm mt-2">Die besten Athleten unseres Vereins — nach Game.</p>
      </div>

      <div className="flex gap-2 flex-wrap">
        {GAMES.map((g) => (
          <button
            key={g}
            onClick={() => setGame(g)}
            data-testid={`game-filter-${g.replace(/\s+/g, "-").toLowerCase()}`}
            className={`px-4 py-2 rounded-sm text-xs uppercase tracking-[0.2em] font-mono border transition-colors ${
              game === g
                ? "bg-primary/10 border-primary text-primary"
                : "border-border text-white/60 hover:border-primary/40 hover:text-white"
            }`}
          >
            {g}
          </button>
        ))}
      </div>

      <div className="card-solid overflow-hidden">
        {loading ? (
          <div className="p-10 text-center font-mono text-xs uppercase tracking-[0.2em] text-white/40">Loading…</div>
        ) : entries.length === 0 ? (
          <div className="p-10 text-center font-mono text-xs uppercase tracking-[0.2em] text-white/40">
            Noch keine Einträge für {game}.
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-white/10 text-white/40">
                <th className="text-left p-4 font-mono text-[10px] uppercase tracking-[0.2em]">Rank</th>
                <th className="text-left p-4 font-mono text-[10px] uppercase tracking-[0.2em]">Spieler</th>
                <th className="text-right p-4 font-mono text-[10px] uppercase tracking-[0.2em]">Pts</th>
                <th className="text-right p-4 font-mono text-[10px] uppercase tracking-[0.2em] hidden md:table-cell">W</th>
                <th className="text-right p-4 font-mono text-[10px] uppercase tracking-[0.2em] hidden md:table-cell">L</th>
                <th className="text-right p-4 font-mono text-[10px] uppercase tracking-[0.2em] hidden md:table-cell">D</th>
                <th className="text-right p-4 font-mono text-[10px] uppercase tracking-[0.2em]">Win%</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((e) => (
                <tr
                  key={e.user_id}
                  data-testid={`leaderboard-row-${e.user_id}`}
                  className="border-b border-white/5 hover:bg-white/5 transition-colors"
                >
                  <td className="p-4 font-mono tabular-nums">
                    <div className={`flex items-center gap-2 ${rankColor(e.rank)}`}>
                      {e.rank <= 3 && <Medal className="w-4 h-4" strokeWidth={1.5} />}
                      <span className="text-base font-bold">{String(e.rank).padStart(2, "0")}</span>
                    </div>
                  </td>
                  <td className="p-4">
                    <div className="flex items-center gap-3">
                      {e.picture ? (
                        <img src={e.picture} alt="" className="w-8 h-8 object-cover rounded-sm border border-white/10" />
                      ) : (
                        <div className="w-8 h-8 bg-primary/10 border border-primary/30 text-primary flex items-center justify-center font-mono text-xs rounded-sm">
                          {e.name?.[0]?.toUpperCase()}
                        </div>
                      )}
                      <div>
                        <div className="font-medium">{e.name}</div>
                        <div className="font-mono text-[10px] text-white/40 uppercase tracking-widest">{e.member_id}</div>
                      </div>
                    </div>
                  </td>
                  <td className="p-4 text-right font-mono tabular-nums text-primary">{e.points}</td>
                  <td className="p-4 text-right font-mono tabular-nums hidden md:table-cell text-accent">{e.wins}</td>
                  <td className="p-4 text-right font-mono tabular-nums hidden md:table-cell text-red-400">{e.losses}</td>
                  <td className="p-4 text-right font-mono tabular-nums hidden md:table-cell text-white/60">{e.draws}</td>
                  <td className="p-4 text-right font-mono tabular-nums">{e.win_rate}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
